import './DetailsDialog.scss';
import { Modal, Typography } from '@mui/material';
import {useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import StatusBadge from '../../StatusBadge/StatusBadge';
import TrapFocus from '@mui/material/Unstable_TrapFocus';

interface Props {
  issueId: string;
  fields: any;
  open: boolean;
  staticContent: any;
  status: string;
  title: string[];
  handleOnClose: () => void;
  handleOnKeyDown: (event: React.KeyboardEvent<SVGSVGElement>) => void;
}

const DetailsDialog = ({
  issueId,
  fields,
  open,
  staticContent,
  title,
  status,
  handleOnClose,
  handleOnKeyDown
}: Props) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const [ariaHidden, setAriaHidden] = useState(true);
 
  // Focus the title when modal opens
 
  useEffect(() => {
    if (open) {
      if (titleRef.current) {
        titleRef.current?.focus();
      }
      setAriaHidden(true);
      const timer = setTimeout(() => {
        setAriaHidden(false);
      }, 1500); // 1.5 seconds
      return () => clearTimeout(timer);
    } else {
      setAriaHidden(true);
    }
  }, [open]);
 
 
  return (
      <Modal
        className="details-dialog"
        open={open ?? false}
        onClose={handleOnClose}
        role="dialog"
        
      > 
      <TrapFocus open={open} initialFocusRef={titleRef} >
        <div className="details-dialog-content"
          role="dialog"
          aria-modal="true"
          aria-labelledby='details-dialog-title'
          
        >
          <div className="dialog-title">
            <div className="container-title"
              // id="details-dialog-title" 
            >
              <Typography
                component="h2"
                className="title"
                ref={titleRef}
                id="details-dialog-title"
                tabIndex={0}
              >
                {title}
              </Typography>
              <StatusBadge status={status} statuses={staticContent.statuses} />
            </div>
            <CloseIcon
              className="icon-close"
              role="button"
              aria-label="close dialog"
              tabIndex={0}
              onClick={handleOnClose}
              onKeyDown={(e) => handleOnKeyDown(e)}
            />
          </div>
          <div
            aria-hidden={ariaHidden}
            className="dialog-content"
          >
            {Object.entries(fields).map(([key, value], index) => {
              let label;
              if (key === 'summary') {
                label = 'Title';
              } else if (key === 'details') {
                label = 'Summary';
              } else {
                label = staticContent.fields[key] ?? key;
              }
              return (
                <div key={index}>
                  <b>{label}</b>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: (Array.isArray(value)
                        ? value.map((item) => item.value).join(', ')
                        : String(value)) as any
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
        </TrapFocus>
      </Modal>
    
  );
 };

export default DetailsDialog;
